module.exports = __webpack_public_path__ + "img/cell-phone-hand.3d817115.png";